"use strict";
import {lazyloading_init} from "./js_common/_dzs_lazyloading";
import {dzs_view_anchorScroll_init} from "./js_common/_dzs_anchorScroll";

const MENU_OFFSET_BG_TRIGGER_PX = 90;

new Promise((resolve) => {
  const checkInt = setInterval(() => {
    if (window.jQuery) {
      clearInterval(checkInt);
      resolve('loaded');
    }
  }, 10);
}).then(() => {
  onJQueryReady();
})

function onJQueryReady() {

  jQuery(document).ready(function ($) {
    lazyloading_init();
    $(window).on('scroll', handle_scroll)

    dzs_view_anchorScroll_init()


    $(document).on('click', '.responsive-selector,.showmore-sticky-con', handle_mouse);

    handle_scroll();

    function handle_scroll() {
      var st = $(window).scrollTop();

      if (st > MENU_OFFSET_BG_TRIGGER_PX) {
        $('.mcon-mainmenu').addClass('left-top');
      } else {

        $('.mcon-mainmenu').removeClass('left-top');
      }

    }


    function handle_mouse(e) {
      var _t = $(this);

      if (_t.hasClass('responsive-selector')) {

        _t.parent().toggleClass('menu-opened');
      }

      if (_t.hasClass('showmore-sticky-con')) {

        $('.showmore-sticky-target').toggleClass('extend-it');
      }

    }
  });


  $(window).on("load", function () {
    var $ = jQuery;

    $('body').addClass('loaded-all');

    $('.load-on-window-load').each(function () {
      var _t = $(this);

      _t.css('background-image', 'url(' + _t.attr('data-src') + ')')
      _t.removeAttr('data-src')
    });



    const link = document.createElement("link");
    link.href = 'fontawesome/font-awesome.min.css';
    link.type = "text/css";
    link.rel = "stylesheet";
    link.media = "all";

    document.getElementsByTagName("head")[0].appendChild(link);

  });
}

